import { render, staticRenderFns } from "./SubGoal.vue?vue&type=template&id=62daa559"
import script from "./SubGoal.vue?vue&type=script&lang=js"
export * from "./SubGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports